// Uzbek practice area string → Russian translation
const PA_RU = {
  // Parent categories
  'Оила ҳуқуқи': 'Семейное право',
  'Фуқаролик ҳуқуқи': 'Гражданское право',
  'Меҳнат ҳуқуқи': 'Трудовое право',
  'Жиноят ҳуқуқи': 'Уголовное право',
  'Тадбиркорлик ҳуқуқи': 'Предпринимательское право',
  'Қурилиш ҳуқуқи': 'Строительное право',
  'Маъмурий ҳуқуқбузарлик': 'Административные правонарушения',
  'Бошқа турдаги ишлар': 'Другие виды дел',
  // Family
  'Никоҳни бекор қилиш (Ажрашиш)': 'Расторжение брака (Развод)',
  'Алимент ундириш': 'Взыскание алиментов',
  'Мерос масаласи': 'Вопросы наследства',
  'Мол-мулкни бўлиш ёки олиб бериш': 'Раздел или передача имущества',
  'Бола билан учраштириш': 'Встреча с ребёнком',
  'Болани олиб бериш': 'Передача ребёнка',
  'Уйга киритиш': 'Вселение в жильё',
  'Уйдан чиқариш': 'Выселение из жилья',
  'Оила ҳуқуқи (бошқа)': 'Семейное право (другое)',
  // Civil
  'Қарз (пул) ундириш': 'Взыскание долга (денег)',
  'Субсидия': 'Субсидия',
  'Кредит олиш': 'Получение кредита',
  'Чегарага тақиқ қўйиш ёки тақиқни ечиш': 'Запрет на выезд или его снятие',
  'Олди-сотди муносабатлари': 'Купля-продажа',
  'Солиқ низолари': 'Налоговые споры',
  'Ер низолари': 'Земельные споры',
  'Кўчмас мулк низолари': 'Споры о недвижимости',
  'Бино (уй, квартира) кадастр қилиш': 'Кадастрирование здания (дома, квартиры)',
  'Истеъмолчи ҳуқуқини бузиш': 'Нарушение прав потребителей',
  'Фуқаролик ҳуқуқи (бошқа)': 'Гражданское право (другое)',
  // Labor
  'Ишга кириш': 'Трудоустройство',
  'Ишга тиклаш': 'Восстановление на работе',
  'Иш ҳақи ундириш': 'Взыскание заработной платы',
  'Компенсация ундириш': 'Взыскание компенсации',
  'Интизомий жазони бекор қилиш': 'Отмена дисциплинарного взыскания',
  'Меҳнат ҳуқуқи (бошқа)': 'Трудовое право (другое)',
  // Criminal
  'Фирибгарлик': 'Мошенничество',
  'Ўғрилик': 'Кража',
  'Баданга шикаст етказиш': 'Причинение вреда здоровью',
  'Безорилик': 'Хулиганство',
  'Гиёҳвандлик': 'Наркотики',
  'Ўзлаштириш ва растрата йўли билан талон-тарож қилиш': 'Присвоение и растрата',
  'Жиноят ҳуқуқи (бошқа)': 'Уголовное право (другое)',
  // Business
  'Тадбиркорлик очиш (рўйхатдан ўтказиш)': 'Открытие бизнеса (регистрация)',
  'Солиқ низолари (текширув)': 'Налоговые споры (проверка)',
  'Ортиқча солиқни қайтариш': 'Возврат излишне уплаченного налога',
  'Шартнома тайёрлаш': 'Составление договора',
  'Имтиёзни қўллаш ва олиш': 'Применение и получение льгот',
  'Божхона низолари': 'Таможенные споры',
  'Таъсис ҳужжатлари тайёрлаш (ўзгартириш, қўшиш)': 'Подготовка учредительных документов',
  'Тадбиркорликни ёпиш (реестрдан чиқариш)': 'Закрытие бизнеса (ликвидация)',
  'Патентлаш (интеллектуал мулк ҳуқуқи)': 'Патентование (интеллектуальная собственность)',
  'Тадбиркорлик ҳуқуқи (бошқа)': 'Предпринимательское право (другое)',
  // Construction
  'Қурилишга рухсат олиш': 'Получение разрешения на строительство',
  'Қурилиш жараёни ҳужжатларини тайёрлаш': 'Подготовка документов строительного процесса',
  'Кадастр ҳужжатларини тайёрлаш': 'Подготовка кадастровых документов',
  'Қурилишни якунлаш ва объектни фойдаланишга қабул қилиш': 'Завершение строительства и ввод объекта',
  'Кўчирма (давлат рўйхатидан ўтказиш) олиш': 'Получение выписки (госрегистрация)',
  'Қурилиш ҳуқуқи (бошқа)': 'Строительное право (другое)',
  // Administrative
  'ГАИ жаримаси': 'Штраф ГАИ',
  'Майда безорилик': 'Мелкое хулиганство',
  'Милиция жарималар': 'Штрафы полиции',
  'Милиция олиб кетди': 'Задержание полицией',
  'Суд жаримаси': 'Судебный штраф',
  'Маъмурий ҳуқуқбузарлик (бошқа)': 'Административное правонарушение (другое)',
};

export function translatePA(str, language) {
  if (language !== 'ru') return str;
  return PA_RU[str] || str;
}
